'use strict';

global.chat = require('./frontend-chat.js');
global.timeDelayFade = 10000;

/**
 * User story:
 *
 * mostro il powwow newsletter dopo 50 secondi all'accesso del sito
 * alla chiusura del powwow newsletter dopo 50 secondi mostro il powwow chat
 *
 * @type {{init: module.exports.init, showNewsletterPowwow: module.exports.showNewsletterPowwow, hideNewsletterPowwow: module.exports.hideNewsletterPowwow, showChatPowwow: module.exports.showChatPowwow, hideChatPowwow: module.exports.hideChatPowwow}}
 */

var self = module.exports = {
    init: function () {

        if (typeof global.hidePowwowNewsletter == 'undefined') {
            global.hidePowwowNewsletter = false;
        }

        /**
         * Se il powwow newsletter non è stato nascosto lo mostro
         */
        if(cookieManager.getCookie('c-powwow-newsletter-hide') !== 'true' && !global.hidePowwowNewsletter) {
            setTimeout(self.showNewsletterPowwow, global.timeDelayFade);
        }

        document.querySelector("[data-js='close-newsletter-powwow']").addEventListener("click", function () {
            self.hideNewsletterPowwow();
        });

        /**
         * Se il powwow newsletter è stato nascosto ma il powwow chat no,
         * mostro quest'ultimo
         */
        if(cookieManager.getCookie('c-powwow-newsletter-hide') === 'true' && cookieManager.getCookie('c-powwow-chat-hide') !== 'true') {
            setTimeout(self.showChatPowwow, global.timeDelayFade);
        }
    },

    showNewsletterPowwow: function () {
        document.querySelector("[data-js='newsletter-powwow']").classList.remove("translate-y-full");
    },

    hideNewsletterPowwow: function () {
        document.querySelector("[data-js='newsletter-powwow']").classList.add("translate-y-full");
        setTimeout(self.showChatPowwow, global.timeDelayFade);
        cookieManager.setCookie('c-powwow-newsletter-hide', 'true', 15);
    },

    showChatPowwow: function () {
        document.querySelector("[data-js='chat-powwow']").classList.remove("translate-y-full");

        document.querySelector("[data-js='close-chat-powwow']").addEventListener("click", function () {
            self.hideChatPowwow();
        });

        document.querySelector("[data-js='chat-open']").addEventListener("click", function () {
            document.querySelector("[data-js='chat']").classList.remove("opacity-0", "pointer-events-none");
			document.querySelector("[data-js='chat-keyboard']").classList.remove("translate-y-full");

            chat.read();
            self.hideChatPowwow();
        });
    },

    hideChatPowwow: function () {
        document.querySelector("[data-js='chat-powwow']").classList.add("translate-y-full");
        cookieManager.setCookie('c-powwow-chat-hide', 'true', 15);
    }
};

self.init();
